export const toCamelCase = (str: string) => {
  if (!str) {
    str = '';
  }
  return str
    .toLowerCase()
    .split(' ')
    .map((word, index) =>
      index === 0
        ? word
        : word.charAt(0).toUpperCase() + word.slice(1)
    )
    .join('');
}

export const resolveFieldValue = (data: any, key: string) => {
  if (!key.includes('.')) {
    return data[key];
  }
  return key.split('.').reduce((acc, part) => acc && acc[part], data);
}

export const getKeyForFormField = (form: any, parentForm: any, bindKeyIndex: number) => {
  let key = form.label;
  if (parentForm && parentForm.label) {
    key = `${parentForm.label}.${form.label}`;
  }
  if (bindKeyIndex !== -1) {
    key = `${form.label}_${bindKeyIndex}`;
  }
  return key;
}

export const handleKeyForTouch = (obj: any, formValues: any) => {
  let keys = Object.keys(formValues);
  for (let key of keys) {
    if (formValues[key] !== undefined || formValues[key] !== null) {
      if (typeof formValues[key] === "object") {
        if (!obj[key]) {
          obj[key] = {};
        }
        handleKeyForTouch(obj[key], formValues[key]);
      } else {
        obj[key] = true;
      }
    }
  }
  return obj;
}


export const getOptionToSetTouched = (formValue: any) => {
  let obj: any = {};
  handleKeyForTouch(obj, formValue);
  return obj;
}
